import React from 'react';

const DebugPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '200vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    }}>
      <h1>React Debug Page</h1>
      <p>This is a minimal React page to test iOS Safari navigation bar hiding.</p>
      
      {/* 十分な高さのコンテンツを生成 */}
      {Array.from({ length: 50 }, (_, i) => (
        <div key={i} style={{ 
          margin: '20px 0', 
          padding: '20px', 
          background: 'rgba(255, 255, 255, 0.1)', 
          borderRadius: '10px' 
        }}>
          <h2>Section {i + 1}</h2>
          <p>Testing scroll content for iOS Safari navigation bar hiding functionality.</p>
          <p>This should allow natural scrolling and trigger Safari UI hiding behavior.</p>
        </div>
      ))}
      
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h2>End of Content</h2>
        <p>Safari navigation bar should hide when scrolling this page.</p>
      </div>
    </div>
  );
};

export default DebugPage;